<!-- In order not to mix `<atx-stepper>` with `<cdk-step>`  
  CdkStep was extended to create our custom component. AtxStepper needs
ng-template to render the content of the step -->

<ng-template>
  <ng-content></ng-content>
</ng-template>
